import { render } from "./Inventory_Branch_Selector.vue?vue&type=template&id=d52f2df8&scoped=true&ts=true"
import script from "./Inventory_Branch_Selector.vue?vue&type=script&lang=ts"
export * from "./Inventory_Branch_Selector.vue?vue&type=script&lang=ts"

import "./Inventory_Branch_Selector.vue?vue&type=style&index=0&id=d52f2df8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d52f2df8"]])

export default __exports__